import React from 'react';
import { Button, Tree } from 'antd';
import { connect } from 'dva';
import { FormattedMessage } from 'react-intl';

const TreeNode = Tree.TreeNode;

class AddRoom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedKeys: [],
      selectedRoomIds: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    const { visible } = nextProps;
    if (!visible) {
      this.setState({
        checkedKeys: [],
        selectedRoomIds: ''
      });
    }
  }

  render() {
    const { onOk, onClose, meetingControl,intl } = this.props;
    const { CMMARooms } = meetingControl;
    console.log("CMMARooms",this.props)
    /**
     * 选中的节点包含父节点，我们系统产生的会议室默认为：区域-楼层-会议室
     * 对应的节点id为1-2-3，按“-”截取后为3位，否为父级节点
     * @param {被选中的节点} checkedKeys
     */
    const onCheck = checkedKeys => {
      let selectedRoomIds = checkedKeys.reduce((joinStr, next) => {
        let roomArr = next.split('-');
        return roomArr.length === 3
          ? joinStr === ''
            ? joinStr + roomArr.pop().split('&')[1]
            : `${joinStr},${roomArr.pop().split('&')[1]}`
          : joinStr;
      }, '');
      this.setState({
        checkedKeys,
        selectedRoomIds
      });
    };

    return (
      <div className={'select-room-container'}>
        <Tree checkable onCheck={onCheck} checkedKeys={this.state.checkedKeys}>
          {CMMARooms.map(zone => (
            <TreeNode title={zone.name} key={zone.id}>
              {zone.child &&
                zone.child.map(floor => (
                  <TreeNode title={floor.name} key={`${zone.id}-${floor.id}`}>
                    {floor.rooms &&
                      floor.rooms.map(room => (
                        <TreeNode
                          title={intl.locale === 'en_US'?room.nameEn:room.name}
                          key={`${zone.id}-${floor.id}-${room.id}&${
                            room.cmmaRoomId
                          }`}
                        />
                      ))}
                  </TreeNode>
                ))}
            </TreeNode>
          ))}
        </Tree>
        <div className={'operate'}>
          <div
            className={'btn'}
            onClick={() => onOk(this.state.selectedRoomIds)}
          >
            <FormattedMessage id="mc_btn_ok" />
          </div>
          <div className={'btn'} onClick={onClose}>
            <FormattedMessage id="mc_btn_cancel" />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({ meetingControl: state.meetingControl }))(
  AddRoom
);



// WEBPACK FOOTER //
// ./src/components/AddRoom.js